import React from 'react'
import { configureStore } from '@reduxjs/toolkit'
// import userReducer from './reducers/userReducer'
import builderReducer from './reducers/builderReducers/builderReducer'
import textEditorReducer from './reducers/textEditor/textEditorReducer'

const store = configureStore({
  reducer: {
    // @ts-ignore
    // user: userReducer, // Still in development
    builder: builderReducer,
    // @ts-ignore
    textEditor: textEditorReducer, // Shouldnt this be in builderReducer?
  },
  devTools: {
    actionsDenylist: ["MOUSE_MOVE", "DRAG_UPDATE", "UPDATE_WEBSITE", "UPDATE_REUSABLE_COMPONENTS", "SET_FONT_URL", "UPDATE_COLORS"],
    trace: true,
    traceLimit: 25,
  },
  
  // @ts-ignore
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false, // Disabled for ImmutableJS
    }),
})

export default store
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
